import React from 'react';
import { useParams } from 'react-router-dom';
import CustomerServiceRequestView from '@/components/service-requests/CustomerServiceRequestView';

const CustomerServiceRequest = () => {
  const { requestId, requestToken } = useParams<{ requestId: string; requestToken: string }>();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="container py-8 px-4 md:px-6 lg:px-8">
        <CustomerServiceRequestView 
          requestId={requestId} 
          requestToken={requestToken} 
        />
      </div>
    </div>
  );
};

export default CustomerServiceRequest; 